/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleinnermotorstrong4Inputs */



/**
* | output |
* | --- |
* | "You know how to use your emotions as a source of energy and motivation to move towards your goals and handle your tasks." |
*
* @param {Eisubscaleinnermotorstrong4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleinnermotorstrong4 = /** @type {((inputs?: Eisubscaleinnermotorstrong4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleinnermotorstrong4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You know how to use your emotions as a source of energy and motivation to move towards your goals and handle your tasks.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sabes usar tus emociones como fuente de energía y motivación para avanzar hacia tus metas y afrontar tus tareas.")
	return /** @type {LocalizedString} */ ("Ты умеешь использовать свои эмоции как источник энергии и мотивации, чтобы двигаться к целям и справляться с задачами.")
});
export { eisubscaleinnermotorstrong4 as "eiSubscaleInnerMotorStrong" }